import { Button, Stack, Text } from "@bookingcom/bui-react";
import { ArrowNavLeftIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";

interface AddUserHeaderProps {
  onBack: () => void;
}

export const AddUserHeader = ({ onBack }: AddUserHeaderProps) => {
  const i18n = useI18n();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack gap={0}>
        <Text variant="headline_1">{i18n.trans(t("flights_airline_portal_add_user_header"))}</Text>
        <Text variant="body_2" color="neutral_alt">
          {i18n.trans(t("flights_airline_portal_add_user_subheader"))}
        </Text>
      </Stack>
      <Button variant="secondary" icon={ArrowNavLeftIcon} onClick={onBack}>
        {i18n.trans(t("flights_airline_portal_superuser_back_button"))}
      </Button>
    </Stack>
  );
};
